import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateService {
    static iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

    static convertToDate(body) {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            if (DateService.isIso8601(value)) {
                body[key] = new Date(value);
            } else if (typeof value === 'object') {
                this.convertToDate(value);
            }
        }
    }

    /**
     * Seules les CHAÎNES sont des dates ISO. ⚠️ `regex.test` convertit son argument en
     * chaîne : un tableau d'UN seul élément ISO (`["2026-09-25T06:00:00.000Z"]`) devient
     * cette chaîne, passait le test, et le tableau entier était remplacé par une `Date`
     * (détail de la journée des notifications, 26/09/2026).
     */
    static isIso8601(value) {
        return typeof value === 'string' && DateService.iso8601.test(value);
    }
}